// @ts-nocheck
import {
    BudgetDetailItemModel,
    BudgetDetailViewModel,
    CleanedBudgetDetailItemModel,
    ExpenditureByProductModel,
    ExpenditureByPurchaserModel,
    ExpendituresByManufacturersModel,
    ExpendituresModel,
    InvoiceDetailModel,
    InvoiceDetailsModel,
    InvoiceSummaryModel,
    ManufacturersPickerModel,
    PoPickerModel,
    ReportOrderFrequencyModel,
    ServiceHistoryModel,
} from "@store/Framework/Services/Reporting/ReportingModels";

export const isInvoiceDetail = (report: any): report is InvoiceDetailModel => {
    if (report) {
        return report.items[0]?.unitofmeasure !== undefined;
    }
    return false;
};

export const isInvoiceDetails = (report: any): report is InvoiceDetailsModel => {
    if (report) {
        return report?.invoices[0]?.items[0]?.unitofmeasure !== undefined;
    }
    return false;
};

export const isManufacturersPickerModel = (report: any): report is ManufacturersPickerModel => {
    if (report) {
        return report.items[0]?.name !== undefined;
    }
    return false;
};
export const isInvoiceSummaryModel = (report: any): report is InvoiceSummaryModel => {
    if (report) {
        return "invoiceCount" in report && "items" in report && report.items.length > 0;
    }
    return false;
};

export const isServiceHistoryModel = (report: any): report is ServiceHistoryModel => {
    if (report) {
        if ("items" in report && report.items.length > 0) {
            return "customerNumber" in report && "shipTo" in report && "itemCount" in report && report["itemCount"] > 0;
        }
    }
    return false;
};
export const isPoPickerModel = (report: any): report is PoPickerModel => {
    if (report) {
        return "pos" in report;
    }
    return false;
};
export const isReportOrderFrequencyModel = (report: any): report is ReportOrderFrequencyModel => {
    if (report) {
        return "orderCount" in report && "customerCount" in report && "items" in report && report.items.length > 0;
    }
    return false;
};

export const isExpenditureByProductModel = (report: any): report is ExpenditureByProductModel => {
    if (report) {
        return "items" in report && report.items.length > 0;
    }
    return false;
};
export const isBudgetDetailViewModel = (report: any): report is BudgetDetailViewModel => {
    if (report) {
        return "items" in report && "customers" in report && "itemsCount" in report;
    }
    return false;
};
export const isBudgetDetailItemModel = (report: any): report is BudgetDetailItemModel => {
    if (report) {
        return "startdate" in report && "enddate" in report && "name" in report && "invoices" in report;
    }
    return false;
};
export const isCleanedBudgetDetailItemModel = (report: any): report is CleanedBudgetDetailItemModel => {
    if (report) {
        return "startdate" in report && "enddate" in report && "name" in report && "invoices" in report;
    }
    return false;
};

export const isExpendituresModel = (report: any): report is ExpendituresModel => {
    if (report) {
        return "items" in report && "customers" in report && "itemsCount" in report && report.itemsCount > 0;
    }
    return false;
};
export const isExpendituresByManufacturersModel = (report: any): report is ExpendituresByManufacturersModel => {
    if (report) {
        if ("items" in report && report.items.length > 0) {
            return "vendorname" in report.items[0];
        }
    }
    return false;
};
export const isExpenditureByPurchaserModel = (report: any): report is ExpenditureByPurchaserModel => {
    if (report) {
        if ("items" in report && report.items.length > 0) {
            return "shiptoaddress" in report.items[0];
        }
    }
    return false;
};
